export interface ReadingUnitData {
  readonly location?: string;
  readonly components?: ReadonlyArray<string>;
}

export interface ContentIndexData {
  readonly readingUnits?: { readonly [id: string]: ReadingUnitData };
}

export function findReadingUnit(index: ContentIndexData, id: string): ReadingUnitData {
  if ((index.readingUnits !== undefined) && (id in index.readingUnits)) {
    return index.readingUnits[id];
  }

  throw new Error('無効なコンテンツです。');
}
